import { render } from "./waitlist-mobile.vue?vue&type=template&id=3da8965a&scoped=true"
import script from "./waitlist-mobile.vue?vue&type=script&lang=js"
export * from "./waitlist-mobile.vue?vue&type=script&lang=js"

import "./waitlist-mobile.vue?vue&type=style&index=0&id=3da8965a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da8965a"]])

export default __exports__